export default __webpack_public_path__ + "static/media/ECE.0323dc53.svg";